// extracted by css-extract-rspack-plugin
var _1 = "L7xnem0fgQ6gZVjW";
var _2 = "ZVziSij2GZ0CeVyE";
var _3 = "kY2xrQ7EWj4_qajF";
var _4 = "C6wFllVjQCQ48StF";
var _5 = "LYkT_bXqW6wpyo49";
var _6 = "svo6A6h6b2cXhTbh";
var _7 = "Sse7oK7zqDo886Ec";
var _8 = "wrxbeBt7nHIo65kb";
var _9 = "GZezL0bce9EWgOG1";
var _a = "YMIkn4cc0eAjhajZ";
var _b = "H1peyt0gsXIhhnkS";
var _c = "ia5t_geZXk4g773d";
var _d = "BPnXupzTqH0pE2zB";
var _e = "bZIEEqVlll8tyEQn";
var _f = "NVtejjokneUYD7lZ";
var _10 = "FCBNhBvPYKlcQmVi";
var _11 = "jz7wLoVeCDcrlTCt";
var _12 = "T43fflgs_SYc2fwV";
var _13 = "ZdpjcGKuI6428Kr3";
var _14 = "w_YpxkWrBI03wKhr";
var _15 = "qwVW5mzRlM2tK5UP";
var _16 = "FhrXHkk4mjkTOF4D";
var _17 = "pWBHyIhs2GgKhuWF";
var _18 = "b3eeiKsYmTQT8nju";
var _19 = "WStceyrorRY9hbZw";
var _1a = "V5wLoNoIirEiTVD0";
var _1b = "ia6MwOCxHskpDEvN";
export { _1 as "bodyCopy0", _2 as "bodyCopy1", _3 as "bodyCopy2", _4 as "buttonBig", _5 as "buttonMedium", _6 as "buttonMicro", _7 as "buttonSmall", _8 as "headline0", _9 as "headline1", _a as "headline2", _b as "headline3", _c as "headline4", _d as "headline5", _e as "headline6", _f as "headline7", _10 as "infoTxt1", _11 as "infoTxt2", _12 as "infoTxt3", _13 as "miniHeader", _14 as "noWrapStyle", _15 as "preserveFontSize", _16 as "strong500", _17 as "strong600", _18 as "strong700", _19 as "textBase", _1a as "textBasePrimary", _1b as "textBaseSecondary" }
// extracted by css-extract-rspack-plugin
var _1 = "L7xnem0fgQ6gZVjW";
var _2 = "ZVziSij2GZ0CeVyE";
var _3 = "kY2xrQ7EWj4_qajF";
var _4 = "C6wFllVjQCQ48StF";
var _5 = "LYkT_bXqW6wpyo49";
var _6 = "svo6A6h6b2cXhTbh";
var _7 = "Sse7oK7zqDo886Ec";
var _8 = "wrxbeBt7nHIo65kb";
var _9 = "GZezL0bce9EWgOG1";
var _a = "YMIkn4cc0eAjhajZ";
var _b = "H1peyt0gsXIhhnkS";
var _c = "ia5t_geZXk4g773d";
var _d = "BPnXupzTqH0pE2zB";
var _e = "bZIEEqVlll8tyEQn";
var _f = "NVtejjokneUYD7lZ";
var _10 = "FCBNhBvPYKlcQmVi";
var _11 = "jz7wLoVeCDcrlTCt";
var _12 = "T43fflgs_SYc2fwV";
var _13 = "ZdpjcGKuI6428Kr3";
var _14 = "w_YpxkWrBI03wKhr";
var _15 = "qwVW5mzRlM2tK5UP";
var _16 = "FhrXHkk4mjkTOF4D";
var _17 = "pWBHyIhs2GgKhuWF";
var _18 = "b3eeiKsYmTQT8nju";
var _19 = "WStceyrorRY9hbZw";
var _1a = "V5wLoNoIirEiTVD0";
var _1b = "ia6MwOCxHskpDEvN";
export { _1 as "bodyCopy0", _2 as "bodyCopy1", _3 as "bodyCopy2", _4 as "buttonBig", _5 as "buttonMedium", _6 as "buttonMicro", _7 as "buttonSmall", _8 as "headline0", _9 as "headline1", _a as "headline2", _b as "headline3", _c as "headline4", _d as "headline5", _e as "headline6", _f as "headline7", _10 as "infoTxt1", _11 as "infoTxt2", _12 as "infoTxt3", _13 as "miniHeader", _14 as "noWrapStyle", _15 as "preserveFontSize", _16 as "strong500", _17 as "strong600", _18 as "strong700", _19 as "textBase", _1a as "textBasePrimary", _1b as "textBaseSecondary" }
